








































































import { Component, Vue } from 'vue-property-decorator'
import http from '@/utils/http'

@Component({
  components: {
  }
})
export default class ForgotPasswordChange extends Vue {

  private showPassword = false
  private password1 = ''
  private password2 = ''
  private message = ''
  private isLoading = false
  private isDone = false

  public submit() {

    if (!this.password1 || this.password1.trim() === '' || !this.password2 || this.password2.trim() === '') {
      this.message = 'Du må fylle ut begge passordfeltene'
      return
    }

    if (this.password1 !== this.password2) {
      this.message = 'Passordene er ikke like'
      return
    }

    this.message = ''
    this.isLoading = true

    const token = this.$route.params.token

    http.post('/auth/forgot-change', { token, password: this.password1 })
      .then((response: any) => {
        this.isDone = true
      })
      .catch((err: any) => {
        this.isLoading = false
        this.message = err.response && err.response.data && err.response.data.errorMessage
          ? err.response.data.errorMessage
          : 'Error communicating with backend (' + err + ')'
      })

  }

  public gotoLogin() {
    this.$router.push('/login')
  }

}
